import { Injectable } from '@angular/core';
import { DatabaseService } from '../alcance/services/database.service';

@Injectable({
  providedIn: 'root'
})
export class PlantaoFormularioDBService extends DatabaseService {
    override classname: string = 'PlantaoFormularioDBService';
    override table = 'plantao_formulario';

    protected override migration: number = 2;

    override indices = [
        { name: "by_id", field: "id", unique: false, multiEntry: false },
        { name: "by_descricao", field: "descricao", unique: false, multiEntry: false }
    ];
}
